import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { translateKey } from 'src/locales/translate';
import { SPAN_FULL } from './medicationFormLayout';

interface MedicationStockOptedOutProps {
  /** The saved record already took the drug: the save gives it back. */
  saved: boolean;
  /** The host holds the form (unconfirmed or saving). */
  disabled: boolean;
  /** "Pobierz jednak". */
  onTakeAgain: () => void;
}

/** "Nie pobieraj z magazynu", collapsed to one line with its undo (#692). */
export default function MedicationStockOptedOut({
  saved,
  disabled,
  onTakeAgain,
}: MedicationStockOptedOutProps): React.ReactElement {
  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      sx={SPAN_FULL}
      data-testid="medication-stock-opted-out"
    >
      <Typography variant="body2" color="text.secondary">
        {translateKey(
          saved
            ? 'warehouse.clinical.optedOutSaved'
            : 'warehouse.clinical.optedOut',
        )}
      </Typography>
      <Button
        size="small"
        disabled={disabled}
        onClick={onTakeAgain}
        data-testid="medication-stock-opt-in"
      >
        {translateKey('warehouse.clinical.optBackIn')}
      </Button>
    </Stack>
  );
}
